import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext({ settings: null });

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/store/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);
  return <StoreContext.Provider value={{ settings }}>{children}</StoreContext.Provider>;
}

export const useStore = () => useContext(StoreContext);
